<template>

  <div
    class="btn-group">
    <button 
      type="button" 
      v-for="(stage, stage_index) in pipeline.stages"
      :key="stage_index"
      class="btn btn-sm"
      :class="{'btn-secondary': !stage.qualified, 'btn-info': stage.qualified}"
      v-tooltip="stage.name">
      {{ stage.qualified }}
      </button>
  </div>

</template>

<script>
export default {
  name: 'JobListPipeline',
  components: {
  },
  props: [
    'pipeline'
  ],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/JobList/JobListPipeline.vue